/* Intelligence Hub — progressive enhancement only.
   Tag-based URL filtering is handled by Shopify server-side; the pills
   are plain <a href> links. This file just smooths the scroll position
   after a filter click so the row list is in view on short viewports. */
(function () {
  'use strict';
  var hub = document.querySelector('.ns-ih');
  if (!hub) return;

  var pills = hub.querySelectorAll('.cat-pill');
  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      try { sessionStorage.setItem('ns_ih_scroll_to_rows', '1'); } catch (_) {}
    });
  });

  try {
    if (sessionStorage.getItem('ns_ih_scroll_to_rows') === '1') {
      sessionStorage.removeItem('ns_ih_scroll_to_rows');
      var rows = document.getElementById('rowList');
      if (rows) {
        window.requestAnimationFrame(function () {
          rows.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  } catch (_) {}
})();
